import { DesktopHeader } from "molecules/navigation/desktop-header/DesktopHeader";
import { useFeatureFlag } from "services/Flags";

/**
 * Covers the page while a route loads. It paints over the app's own desktop header, so it carries
 * that header itself: the placeholder then sits exactly where the page will, sticky offsets included.
 */
export const PendingRouteViewport = ({ children }: { children: React.ReactNode }) => {
  const isDesktopExperience = useFeatureFlag("desktopExperience");

  return (
    <div className="fixed inset-0 z-30 overflow-y-auto bg-white pb-[calc(59px_+_env(safe-area-inset-bottom))] desk:pb-0">
      {isDesktopExperience && <DesktopHeader />}
      {children}
    </div>
  );
};
